import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ValidateEmailPatternDirective } from '../../../shared/validators/validate-email-pattern.directive';
import { EmailValidatorsService } from '../../../validators/email-validators.service';
import { AppContextService } from '../../../shared/services/app-context.service';
import { PasswordResetCode } from '../../../shared/dto/password-reset-response';

@Component({
  selector: 'townip-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class PasswordResetComponent implements OnInit {

  public form: UntypedFormGroup;
  public emailText: string;
  public showText = false;
  public errorMessage: string;
  public loading = false;
  public cancelEnabled = true;

  constructor(public appContext: AppContextService,
              private fb: UntypedFormBuilder,
              private emailValidatorsService: EmailValidatorsService,
              private userService: UserService) {
    this.cancelEnabled = !this.appContext.isAccountPortal();
  }

  public resetPassword(): void {
    if (this.form.invalid) {
      return;
    }

    this.errorMessage = '';
    this.loading = true;
    const email = this.form.getRawValue().email;
    this.emailText = email;
    this.userService
      .resetUserPassword(email)
      .toPromise()
      .then(response => {

        if (response.statusCode === PasswordResetCode.OK) {
          this.showText = true;
          this.loading = false;
          return;

        } else if (response.errMessage) {
          this.errorMessage = response.errMessage;
        } else {
          this.errorMessage = 'EMAIL_NOT_FOUND';
        }

        this.showText = false;
        this.loading = false;
      })
      .catch(() => {
        // any exception just show the default message...
        this.errorMessage = 'EMAIL_NOT_FOUND';
        this.showText = false;
        this.loading = false;
      });
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      email: ['', [Validators.required, ValidateEmailPatternDirective.validateEmailPattern],
        !this.emailValidatorsService.validateInternalUser()]
    });
  }

}
